import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@ant-design/icons';
import '../../../../styles/scheduleInviteTiles.scss';
import { connect } from 'react-redux';
import {handleImportVolunteerDelete} from 'features/EventContainer/redux/actions/volunteersActions';
import ErrorIcon from 'features/EventContainer/components/InviteErrorIcon';
import { useTranslation } from 'react-i18next';

const InviteTile = props => {
  const {t} = useTranslation()
  const {
     errors, data
  } = props;

  const { 
    eventName,type,date,startTime,endTime,panelName,teamNumber,teamName
  }=data

  const isInvalid = Boolean(errors.length);
  const renderErrorMessages = (errorsArray) => {
   
    if (errorsArray.length < 1) return null;
    const errorsRows = errorsArray.map(e => (
      <div className='schedule-invite-tile__error-message-row'>
        <Icon component={ErrorIcon} className='schedule-invite-tile__error-icon' />
        <p className='schedule-invite-tile__error-message'>{e.message}</p>
      </div>
    ))

    return errorsRows;

  }

  //partial match for ceremony types
  function searchCeremonyType(type) {
     return type.includes('open') || type.includes('clos') || type.includes('cerem');
  }

  //partial match for judging types
  function searchJudgingType(type) {
     return type.includes('jud') || type.includes('sess');
  }

  //partial match for match types
  function searchMatchType(type) {
     return type.includes('prac') || type.includes('match') || type.includes('off');
}

  return (
    <div className={isInvalid ? 'schedule-invite-tile schedule-invite-tile--error' : 'schedule-invite-tile'}>
    <div className='schedule-invite-tile__team-col'>
      <div>
      <p className='schedule-invite-tile__team'> 
     
        {eventName ? `${eventName}` : <span className='schedule-invite-tile__missing'>{t('schedulerEventNameEmptyLabel')}</span> }
        {" | "}
        {type ? `${type}` : <span className='schedule-invite-tile__missing'>{t('schedulerTypeEmptyLabel')}</span>}
        {" | "}
        {date ? `${date}` : <span className='schedule-invite-tile__missing'>{t('schedulerDateEmptyLabel')}</span>}
        {" | "}
        {startTime ? `${startTime} ` : <span className='schedule-invite-tile__missing'>{t('schedulerStartTimeEmptyLabel')}</span>}
        {" - "}
        {endTime ? `${endTime} ` : <span className='schedule-invite-tile__missing'>{t('schedulerEndTimeEmptyLabel')}</span>}

        {type && !searchCeremonyType(type.toLowerCase()) ?          
         <>
            {searchJudgingType(type.toLowerCase()) ? 
              (
                <>
                 {" | "}
                {panelName ? `${panelName} ` : <span className='schedule-invite-tile__missing'>{t('schedulerRoomEmptyLabel')}</span>}
                </>
              ):(
              searchMatchType(type.toLowerCase()) ?
                <>
                 {" | "}
                {panelName ? `${panelName} ` : <span className='schedule-invite-tile__missing'>{t('schedulerTableEmptyLabel')}</span>}
                </>
                :null
              )
            }

            {
               searchMatchType(type.toLowerCase()) || searchJudgingType(type.toLowerCase()) ?
                <>
                 {" | "}
                 {teamNumber ? `${teamNumber} ` : <span className='schedule-invite-tile__missing'>{t('schedulerTeamNumberEmptyLabel')}</span>}
                 {" - "}
                 {teamName ? `${teamName} ` : <span className='schedule-invite-tile__missing'>{t('schedulerTeamNameEmptyLabel')}</span>}
                </>
                :null              
            }
           
          </> : (' ')}
        
      </p>
      </div>
      <div>
        {renderErrorMessages(errors)}
      </div>
    </div>

  </div>
  );
};


InviteTile.propTypes = {
  data: PropTypes.array,
  errors: PropTypes.array,
};

InviteTile.defaultProps = {
  errors: [],
}

const mapStateToProps = (state) => {
  const { event: { eventDetails: { is_FLLC_event } } } = state;
 // const {ExportHeader} = eportEventSchedule;

  return {
    is_FLLC_event,
  }
}

export default connect(mapStateToProps, {deleteVolunteer: handleImportVolunteerDelete})(InviteTile);